import React, { useContext } from 'react';
import { ReactComponent as Arrow } from '../../assets/icons/arrow.svg';
import { PanelContext } from './Panel';
import * as S from './styles'

export const PanelButton = () => {
    const { open, toggle, variant } = useContext(PanelContext);

    return (
        <S.PanelButton open={open} onClick={toggle} variant={variant}><Arrow/></S.PanelButton>
    )
}